import React from 'react';

import { notEmpty } from 'utils/ramdaAdditions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import Classifiers from 'components/common/tableComponents/cellTemplates/Classifiers';

const ProjectClassifiers = ({ classifiers }) => notEmpty(classifiers) ? (
    <div>
        <DefinitionHeader translate="classifier" iconType="folder" />
        <div className="panel-view">
            <Classifiers value={classifiers} />
        </div>
    </div>
) : null;

export default ProjectClassifiers;
